<template>
  <div class="qr-code-generator">
    <canvas ref="qrCanvas"></canvas>
    <woot-button
        :title="$t('INTEGRATION_SETTINGS.MOBILE_APP.REFRESH')"
        variant="clear"
        color-scheme="secondary"
        icon="ion-android-refresh"
        @click="generateQRCode"
    />
  </div>
</template>

<script>
import QRCode from 'qrcode';
import authAPI from "../../../../../../api/auth";

export default {
  name: "QrCodeGenerator",
  methods: {
    async generateQRCode() {
      try {
        const response = await authAPI.getQrCode();
        const qrData = response.data.qr_code;
        const canvas = this.$refs.qrCanvas;
        QRCode.toCanvas(canvas, qrData, function (error) {
          if (error) console.error(error);
        });
      } catch (error) {
        console.error('Error fetching QR code data:', error);
      }
    }
  },
  mounted() {
    this.generateQRCode();
  }
};
</script>

<style scoped>
.qr-code-generator {
  display: flex;
}
</style>
